export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_16.6c009b52.jpg";